import styled from "styled-components"

export const SuccessBanner = styled.div`
  position: fixed;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #54cc8a; /* Green background */
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  font-size: 1rem;
  font-weight: bold;
  text-align: center;
  z-index: 1000;
  animation: fadeInOut 3s ease-in-out;

  @keyframes fadeInOut {
    0% {
      opacity: 0;
      transform: translateY(-20px) translateX(-50%);
    }
    10%,
    90% {
      opacity: 1;
      transform: translateY(0) translateX(-50%);
    }
    100% {
      opacity: 0;
      transform: translateY(-20px) translateX(-50%);
    }
  }
`
